import { em } from 'polished'
import styled from 'styled-components'

export const SecondBlock = styled.div`
  padding-bottom: ${em(40)};
  padding-top: ${em(40)};

  ${p => p.theme.mq.upMd} {
    padding-bottom: 0;
    padding-top: 0;
  }
`

export const ThirdBlock = styled.div`
  padding-bottom: ${em(40)};
`
